// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { FundModelResponseFromJSON, FundModelResponseToJSON, } from './';
export function GetFundAndCffModelResponseFromJSON(json) {
    return {
        'id': !exists(json, 'id') ? undefined : json['id'],
        'fundId': !exists(json, 'fundId') ? undefined : json['fundId'],
        'fundName': !exists(json, 'fundName') ? undefined : json['fundName'],
        'assetClass': !exists(json, 'assetClass') ? undefined : json['assetClass'],
        'strategy': !exists(json, 'strategy') ? undefined : json['strategy'],
        'geography': !exists(json, 'geography') ? undefined : json['geography'],
        'investorAccountName': !exists(json, 'investorAccountName') ? undefined : json['investorAccountName'],
        'investorAccountId': !exists(json, 'investorAccountId') ? undefined : json['investorAccountId'],
        'currency': !exists(json, 'currency') ? undefined : json['currency'],
        'commitment': !exists(json, 'commitment') ? undefined : json['commitment'],
        'commitmentDate': !exists(json, 'commitmentDate') ? undefined : new Date(json['commitmentDate']),
        'fundsModel': !exists(json, 'fundsModel') ? undefined : FundModelResponseFromJSON(json['fundsModel']),
    };
}
export function GetFundAndCffModelResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    return {
        'id': value.id,
        'fundId': value.fundId,
        'fundName': value.fundName,
        'assetClass': value.assetClass,
        'strategy': value.strategy,
        'geography': value.geography,
        'investorAccountName': value.investorAccountName,
        'investorAccountId': value.investorAccountId,
        'currency': value.currency,
        'commitment': value.commitment,
        'commitmentDate': value.commitmentDate === undefined ? undefined : value.commitmentDate.toISOString(),
        'fundsModel': FundModelResponseToJSON(value.fundsModel),
    };
}
